<template>
    <span 
        class="tooltip"
        :class="variant"
        @mouseover="show = true"
        @mouseleave="show = false"
    >
        <span class="tooltip-btn info-block"></span>
        <div class="tooltip-text" v-if="show">{{text}}</div>
    </span>
</template>

<script>
export default {
  name: 'tooltip',
  props: {
    text: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'bottom',
    },
    variant: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'full'].includes(value)
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style scoped lang="scss">
    .tooltip {
        position: relative;
        display: inline-block;
        text-align: center;
        top: 16px;
        right: 16px;
        z-index: 3;

        &.full {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            & .tooltip-btn {
              margin: 4px 4px 0 auto;
            }

            & .tooltip-text {
              right: 1.5%;
            }
        }
    }

    .tooltip-btn {
        display: block;
        width: 22px;
        height: 22px;
        cursor: pointer;
        transition: opacity .25s;
        padding-left: 4px;
    }

    .tooltip-text {
        position: absolute;
        bottom: 100%;
        right: 50%;
        width: 132px;
        margin-bottom: 10px;
        padding: 12px;
        color: #999999;
        font-size: 11px;
        line-height: 1.181818;
        text-align: center;
        background-color: #262626;
        border-radius: 4px 4px 0 4px;
        transition: opacity .25s, visibility .25s;

        &:after {
            position: absolute;
            right: 0;
            top: 100%;
            display: block;
            content: "";
            width: 0;
            height: 0;
            border-bottom: 10px solid transparent;
            border-right: 10px solid #262626;
        }
    }
</style>
